import React from 'react';
import ReactComment from './ReactComment';
const ContentAsset = (props) => {
    return React.createElement(ReactComment, { text: `dwMarker="${props.type}" dwContentID="${props.uuid}"` });
};
export default ContentAsset;
